import { facetOptionsReducer as facetOptions } from '../../../features/facet-options/facet-options-slice.js';
import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { sortFacets } from '../../../utils/facet-utils.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * Creates a `FacetManager` instance.
 *
 * @param engine - The headless engine.
 * @returns The `FacetManager` controller instance.
 *
 * @group Controllers
 * @category FacetManager
 */
export function buildCoreFacetManager(engine) {
    if (!loadFacetManagerReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const getState = () => engine.state;
    return {
        ...controller,
        sort(facets) {
            return sortFacets(facets, this.state.facetIds);
        },
        get state() {
            const facets = getState().search.response.facets;
            const facetIds = facets.map((f) => f.facetId);
            return { facetIds };
        },
    };
}
function loadFacetManagerReducers(engine) {
    engine.addReducers({ search, facetOptions });
    return true;
}
